// IMPORTANT: CHECK UTILS/UI BEFORE ADDING TO THIS FILE TO AVOID DUPLICATING FUNCTIONS

// WORK IN PROGRESS
// PUBLISHER LIST

export const PID = {
  aps: '1083',
  amc: '798',
  bitCentral: '810',
  directTV: '804',
  elsonTestingV2: '1095',
  estrellaTV: '1021',
  fanServ: '1216',
  fujiTV: '1172',
  funke: '970',
  griffinMedia: '1296',
  hearst: '851',
  jasonTestPublisher: '723',
  kansaiTV: '1362',
  kennyTesting: '518',
  ottera: '475',
  newsUK: '1027',
  philo: '381',
  plex: '960',
  publica: '1',
  rarefiedAtmosphere: '408',
  roku: '437',
  ruralMediaGroup: '968',
  samsungAU: '642',
  samsungBrazil: '643',
  samsungCA: '1030',
  samsungEU: '486',
  samsungIN: '744',
  samsungKorea: '547',
  samsungMENA: '1208',
  samsungSEA: '1266',
  samsungMX: '654',
  samsungNA: '394',
  sonyProd: '1224',
  sonyUAT: '1343',
  sonyStage: '1344',
  sportsGrid: '1183',
  tastemade: '452',
  tegna: '773',
  tMobile: '584',
  vevo: '1010',
  viacomCBS: '538',
  waipu: '812',
  weatherNation: '1071',
  xumo: '401',
  qaPublica: '760',
};

export const isPublisherPublica = (publisherID: string) => publisherID === PID.publica;

export const isPublisherTest = (publisherID: string): boolean => {
  return [PID.publica, PID.kennyTesting, PID.qaPublica, PID.elsonTestingV2].includes(publisherID);
};

const SAMSUNG_IDS = [
  PID.samsungAU,
  PID.samsungBrazil,
  PID.samsungCA,
  PID.samsungEU,
  PID.samsungIN,
  PID.samsungKorea,
  PID.samsungMENA,
  PID.samsungMX,
  PID.samsungNA,
  PID.samsungSEA,
];
export const isPublisherSamsungNA = (publisherID: string) => publisherID === PID.samsungNA;
export const isPublisherSamsung = (publisherID: string) => SAMSUNG_IDS.includes(publisherID);

export const isPublisherTegna = (publisherID: string): boolean => publisherID === PID.tegna;

// USED FOR PARENT OVERVIEW DASHBOARD
const PARENT_PUBLISHER_IDS = [PID.samsungNA, PID.samsungKorea, PID.roku, PID.ottera, PID.viacomCBS];
export const isPublisherParent = (publisherID: string) => {
  return PARENT_PUBLISHER_IDS.includes(publisherID);
};

export const isLiverampIntegrationEnabled = (liverampDistributionManagerID: string): boolean => {
  if (liverampDistributionManagerID === '' || liverampDistributionManagerID === '0') {
    return false;
  }

  return true;
};

export const doesPublisherHavePilotDesk = (publisherID: string): boolean => {
  return [...SAMSUNG_IDS, PID.plex, PID.philo, PID.xumo].includes(publisherID);
};
